import { useState } from "react";
import { StringParam, useQueryParam } from "routing/QueryParams";
const useInitialCheckParam = () => {
  const [check] = useQueryParam("check", StringParam);
  const [initialCheck] = useState(() => check != null ? check : void 0);
  return initialCheck;
};
export default useInitialCheckParam;
